import { render, staticRenderFns } from "./AddDirectionForm.vue?vue&type=template&id=5744dc7e"
import script from "./AddDirectionForm.vue?vue&type=script&lang=js"
export * from "./AddDirectionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports